import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import AppButton from '../components/AppButton';

export default function Result({route, navigation}: any){
  const {score, total} = route.params;
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Résultats</Text>
      <Text style={styles.score}>{score} / {total}</Text>
      <AppButton title="Rejouer" onPress={()=>navigation.replace('Game')} />
      <View style={{height:8}} />
      <AppButton title="Accueil" onPress={()=>navigation.popToTop()} />
    </View>
  );
}

const styles = StyleSheet.create({container:{flex:1,alignItems:'center',justifyContent:'center'},title:{fontSize:28,fontWeight:'700',marginBottom:10},score:{fontSize:22,marginBottom:20}});
